var map = {
	"./QuickSwap - Smart Contract Security Report.pdf": 1883,
	"./QuickSwap_logo.png": 514,
	"./arkane.svg": 1884,
	"./arrow-down-blue.svg": 1885,
	"./arrow-down-grey.svg": 1886,
	"./arrow-right-white.png": 1887,
	"./arrow-right.svg": 1888,
	"./bitkeep.png": 1889,
	"./bitski.svg": 1890,
	"./blue-loader.svg": 220,
	"./circle-grey.svg": 1891,
	"./circle.svg": 1892,
	"./coinbaseWalletIcon.svg": 299,
	"./dropdown-blue.svg": 1893,
	"./dropdown.svg": 1894,
	"./dropup-blue.svg": 1895,
	"./ethereum-logo.png": 1896,
	"./fortmaticIcon.png": 300,
	"./gnosis_safe.png": 1897,
	"./link.svg": 1898,
	"./logo_circle.png": 297,
	"./magnifying-glass.svg": 1899,
	"./matic.png": 520,
	"./menu.svg": 1900,
	"./metamask.png": 519,
	"./noise.png": 164,
	"./plus-blue.svg": 1901,
	"./plus-grey.svg": 1902,
	"./portisIcon.png": 301,
	"./qsbg.png": 163,
	"./question-mark.svg": 1903,
	"./question.svg": 1904,
	"./quick_logo.jpeg": 521,
	"./spinner.svg": 1905,
	"./token-list/lists-dark.png": 1906,
	"./token-list/lists-light.png": 1907,
	"./token-logo.png": 1908,
	"./trustWallet.png": 1909,
	"./venly.svg": 1910,
	"./walletConnectIcon.svg": 302,
	"./x.svg": 1911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;